import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';
import { ApiConstants } from './core/constants/api.constants';
import { ApiRequestService } from './core/services/api-request.service';
import { AuthService } from './core/services/auth.service';
import { LoggedInUserService } from './core/services/logged-in-user.service';
import { LANGUAGES, TranslateService } from './core/translate';
import { AuthorizedModalComponent } from './shared/components/authorized-modal/authorized-modal.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'tuwaiq-app';
    authenticated = false;
    showLoaderOverlay = false;
    isReady = false;
    showLoader = false;
    subs = new SubSink();
    isBrowser = false;
    hideFooterOnRouterNav = true;
    currentUrl: string;
    isHome: boolean;
    isShowConfirmation: string;

    constructor(
        private cookie: CookieService,
        private authService: AuthService,
        private apiRequestService: ApiRequestService,
        private loggedInUserService: LoggedInUserService,
        private cookies: CookieService,
        private router: Router,
        public dialog: MatDialog,
        private translateService: TranslateService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.setAppLanguage();
        this.loggedInUserService.clearViewAs();
        this.isBrowser = isPlatformBrowser(platformId);
        router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
    }

    setAppLanguage() {
        const userLang = this.cookie.get('user-preferred-language')?.toLowerCase();
        this.translateService.setLang(userLang || LANGUAGES.AR);
    }

    ngOnInit() {
        if (this.isBrowser) {
            this.validateToken();
        }
        this.isShowConfirmation = localStorage.getItem('isShowConfirmation');
    }

    validateToken() {
        let userId = this.cookie.get('userId');
        let userRole = this.cookie.get('userRole');
        if (userId && userRole) {
            this.authService.storeUserAuthenticationStatus(true);
            this.authenticated = true;
            this.getLoggedInUserDetails();
            this.currentUrl = window.location.href;
            const url = this.router.url;
            this.isHome = this.router.url.includes(url);
        } else if ( environment.production === false && environment.preproduction === false ) {
            this.apiRequestService.login(this.getEmailFromUser()).subscribe({
                next: () => {
                    window.location.reload();
                }, complete: () => {
                    window.location.reload();
                }, error: () => {
                    window.location.reload();
                }
            });
        } else {
            window.location.href = ApiConstants.LOGIN;
        }
    }

    getEmailFromUser() {
        let email;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email validation regex
        do {
            email = prompt("Please enter a valid email address:");
            if (emailPattern.test(email)) {
                console.log("Valid email:", email);
            } else {
                alert("Invalid email. Please try again.");
            }
        } while (!emailPattern.test(email));
        return email;
    }
    getLoggedInUserDetails() {
        this.showLoader = true;
        const userId = this.getLoggedUserId();
        this.subs.sink = this.apiRequestService.getUserDetails(userId).subscribe((response: any) => {
            if (response) {  
                this.loggedInUserService.storeLoggedInUserDetails(response.data);      
                if (this.isShowConfirmation != 'true') {
                    this.openAuthorizedPopup();
                }
                this.isReady = true;
                this.showLoader = false;
            }
        });

        //TODO: error message
    }

    getLoggedUserId() {
        if (isPlatformBrowser(this.platformId)) {
            return this.cookies.get('userId');
        } else {
            return null;
        }
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.hideFooterOnRouterNav = true;
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
            this.hideFooterOnRouterNav = false;
        }
    }
    
    openAuthorizedPopup() {
        this.dialog.open(AuthorizedModalComponent, {
            width: '450px',
            disableClose: true
        });
    }

}
